/* Bootstrap */

//import "bootstrap";
// import { Modal } from 'bootstrap'
import { Tab, Collapse, Dropup } from 'bootstrap'

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

/* SwiperJS */
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

// Swiper.use([Scrollbar]);
// init Swiper:

// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// gsap.registerPlugin(ScrollTrigger);

// var Isotope = require('isotope-layout');

import fadeOnScreen from "./js/fadeOnScreen";
fadeOnScreen();

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

import blocks from "./js/blocks";
blocks();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();
